// Component
const PuppyPurchaseStatus = () =>
  import(
    /* webpackPrefetch: true, webpackChunkName: "dog-purchase-transaction-success" */ "@/app/views/client-view/puppy-for-sale-page/components/puppy-purchase-status/puppy-purchase-status.vue"
  );
const PuppyPurchaseFailed = () =>
  import(
    /* webpackPrefetch: true, webpackChunkName: "dog-purchase-transaction-failed" */ "@/app/views/client-view/puppy-for-sale-page/components/puppy-purchase-failed/puppy-purchase-failed.vue"
  );
const ClientHeader = () =>
  import(
    /* webpackPrefetch: true, webpackChunkName: "client-header" */ "@/app/views/client-view/_shared/client-header/client-header.vue"
  );
const TheFooter = () =>
  import(
    /* webpackPrefetch: true, webpackChunkName: "the-footer" */ "@/app/views/main-view/_shared/the-footer/the-footer.vue"
  );

// Constants
import { STATUS_CODES } from "@/app/constants/status-constants";

// Services
import puppySellService from "@/app/services/main/puppy-sell/puppy-sell-service.js";

export default {
  name: "PuppyPurchase",
  components: {
    PuppyPurchaseStatus,
    PuppyPurchaseFailed,
    ClientHeader,
    TheFooter,
  },
  directive: {},
  filters: {},
  mixins: [],
  props: {},
  data() {
    return {
      message: "",
      selectedRoute: "",
      isAPILoading: true,
      puppyPurchaseDetails: null,
    };
  },
  computed: {
    isNativeApp() {
      return this.$store.getters.getIsNativeApp;
    },
  },
  watch: {},
  async created() {
    if (this.$route.query.status && this.$route.query.referenceId) {
      const { status, referenceId, token } = this.$route.query;
      if (status === "success") {
        await this.getPuppyPurchaseDetails(referenceId, token);
      } else {
        this.setFailedStatus();
        this.isAPILoading = false;
      }
    } else if (
      this.$route.query.gatewayReference &&
      this.$route.query.transactionReference
    ) {
      const { gatewayReference, merchantReference, transactionReference } =
        this.$route.query;
      this.purchaseVerify(
        gatewayReference,
        merchantReference,
        transactionReference
      );
    } else {
      const { token, reference, message, result, signature } =
        this.$route.query;
      this.purchaseVerifyPlus(token, reference, message, result, signature);
      this.isAPILoading = false;
    }

  },
  methods: {
    //latitudePayCard
    purchaseVerify(gatewayReference, merchantReference, transactionReference) {
      this.isAPILoading = true;
      puppySellService
        .purchasePuppyVerify({
          gatewayReference,
          merchantReference,
          transactionReference,
        })
        .then((res) => {
          if (res.status === STATUS_CODES.SUCCESS) {
            if (res.data.result === "completed") {
              this.getPuppyPurchaseDetails(merchantReference, gatewayReference);
            } else {
              this.setFailedStatus(merchantReference);
            }
          } else {
            this.setFailedStatus(merchantReference);
          }
      }).catch(() => {
        this.showGenericErrorToast();
      }).finally(() => {
          this.isAPILoading = false;
      });
    },
    // latitudePayPlus
    purchaseVerifyPlus(token, reference, message, result, signature) {
      this.isAPILoading = true;
      puppySellService
        .purchasePuppyVerifyPlus({
          token,
          reference,
          message,
          signature,
        })
        .then((res) => {
          if (res.status === STATUS_CODES.SUCCESS) {
            if (res.data.status === "APPROVED") {
              this.getPuppyPurchaseDetails(reference, token);
            } else {
              this.setFailedStatus(reference);
            }
          } else {
            this.setFailedStatus(reference);
          }
        });
    },
    async getPuppyPurchaseDetails(merchantReference, token) {
      this.isAPILoading = true;
      await puppySellService
        .getPuppyPurchase({
          referenceId: merchantReference,
          token: token,
        })
        .then((res) => {
          if (res.status === STATUS_CODES.SUCCESS) {
            this.puppyPurchaseDetails = res.data;
          } else {
            this.puppyPurchaseDetails = null;
          }
        }).finally(() => {
            this.isAPILoading = false;
        });

      this.selectedRoute = "puppy-purchase-status";

      const path = `/puppy-purchase-status`;

      if (
        this.$route.path !== path ||
        this.$route.query.status !== "success" ||
        this.$route.query.referenceId !== merchantReference
      ) {
        this.$router.replace(
          `/puppy-purchase-status?status=success&referenceId=${merchantReference}&token=${token}`
        );

        // await puppySellService.sendEmailPuppyPurchase({
        //   referenceId: merchantReference,
        //   token: token,
        // });
      }
    },
    setFailedStatus(merchantReference) {
      this.selectedRoute = "puppy-purchase-failed";

      const path = `/puppy-purchase-status`;
      if (this.$route.path !== path || this.$route.query.status !== "failed")
        this.$router.replace(
          `/puppy-purchase-status?status=failed&referenceId=${merchantReference}`
        );
    },
  },
  // third party libraries 
};
